import React, { useCallback, useEffect, useRef, useState } from 'react';

/** Own the inactivity timer without rerendering or restarting the camera player. */
const CameraTile: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [controlsVisible, setControlsVisible] = useState(true);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const showControls = useCallback(() => {
    setControlsVisible(true);
    if (timer.current !== null) clearTimeout(timer.current);
    timer.current = setTimeout(() => setControlsVisible(false), 3000);
  }, []);

  useEffect(() => {
    showControls();
    return () => { if (timer.current !== null) clearTimeout(timer.current); };
  }, [showControls]);

  return (
    <div className="camera-tile relative w-full h-full bg-black group"
      data-controls-visible={controlsVisible}
      onPointerEnter={showControls}
      onPointerMoveCapture={showControls}
      onPointerDownCapture={showControls}>
      {children}
    </div>
  );
};

export default CameraTile;
